<template>
  <div>
    <div class="breadcrumbs">
      <div class="container">
        <a href="/">首页</a> <span class="sep">/</span> <span>交易订单</span>
      </div>
    </div>
    <div class="mi-orderlist">
      <div class="container ">
        <div class="row">
          <div class="span4">
            <left-nav></left-nav>
          </div>
          <div class="span16">
            <div class="uc-box uc-main-box">
              <div class="uc-content-box order-list-box">
                <div class="box-hd">
                  <h1 class="title">
                    采购订单
                  </h1>
                  <div class="more clearfix">
                    <ul class="filter-list">
                      <li
                        class="first"
                        :class="getTabClass('ALL')"
                        @click="onClickTab('ALL')"
                      >
                        <a
                          data-stat-id="57897755adc8c1e0"
                          href="javascript:void(0);"
                          >全部</a
                        >
                      </li>
                      <li
                        :class="getTabClass('WAIT_PAY')"
                        @click="onClickTab('WAIT_PAY')"
                      >
                        <a href="javascript:void(0);">
                          待支付
                        </a>
                      </li>
                      <li
                        :class="getTabClass('WAIT_CONFIRM')"
                        @click="onClickTab('WAIT_CONFIRM')"
                      >
                        <a href="javascript:void(0);">
                          待收货
                        </a>
                      </li>
                      <li
                        :class="getTabClass('TRADE_SUCCESS')"
                        @click="onClickTab('TRADE_SUCCESS')"
                      >
                        <a href="javascript:void(0);">
                          已收货
                        </a>
                      </li>
                      <li
                        :class="getTabClass('IS_DEL')"
                        @click="onClickTab('IS_DEL')"
                      >
                        <a
                          data-stat-id="1591d5f9a89e8bb6"
                          href="javascript:void(0);"
                          >回收站</a
                        >
                      </li>
                    </ul>
                    <div class="search-form clearfix">
                      <label for="search" class="hide">站内搜索</label
                      ><input
                        type="search"
                        autocomplete="off"
                        placeholder="输入商品名称、订单号"
                        class="search-text"
                        v-model="form.keyword"
                      /><input
                        type="button"
                        value=""
                        class="search-btn iconfont"
                      />
                    </div>
                  </div>
                </div>
                <div class="box-bd" v-loading="is_loading">
                  <el-empty
                    description="暂无数据"
                    v-show="table_data.length === 0"
                  ></el-empty>
                  <div>
                    <ul class="order-list">
                      <li
                        data-v-1df9de88=""
                        class="uc-order-item uc-order-item-finish"
                        v-for="(item, index) in table_data"
                        :key="index"
                      >
                        <div
                          data-v-1df9de88=""
                          class="order-remove"
                          @click="onDel(item, index)"
                        >
                          <img
                            data-v-1df9de88=""
                            src="//i1.mifile.cn/f/i/2019/order/trash.png"
                            alt="垃圾桶"
                          />
                        </div>
                        <div data-v-1df9de88="" class="order-detail">
                          <div class="order-summary">
                            <div class="order-status">
                              {{ item.status_text }}
                              <!---->
                            </div>
                            <!----><!---->
                          </div>
                          <table class="order-detail-table">
                            <thead>
                              <tr>
                                <th class="col-main">
                                  <p class="caption-info">
                                    {{ item.create_time }}
                                    <span class="sep">|</span>
                                    {{ item.user_name }}
                                    <span class="sep">|</span>
                                    订单号：<span>{{ item.order_no }}</span
                                    ><span class="sep"></span
                                    ><!---->
                                  </p>
                                  <p
                                    class="caption-info"
                                    v-show="item.express_no"
                                  >
                                    {{ item.express_type }}
                                    <span class="sep">|</span>
                                    {{ item.express_company }}
                                    <span class="sep">|</span>
                                    单号：<span>{{ item.express_no }}</span
                                    ><span class="sep"></span
                                    ><!---->
                                  </p>
                                </th>
                                <th class="col-sub" style="padding-bottom:7px;">
                                  <p class="caption-price">
                                    商品总价：
                                    <span
                                      style="width:90px;display:inline-block;color:red;font-weight:bold;font-size:16px;"
                                      >{{ item.total_amount }}</span
                                    >
                                    元
                                  </p>
                                  <p class="caption-price">
                                    运费：
                                    <span
                                      style="width:90px;display:inline-block;color:red;font-weight:bold;font-size:16px;"
                                      >{{ item.freight_amount }}</span
                                    >
                                    元
                                  </p>
                                  <p class="caption-price">
                                    实付金额：
                                    <span
                                      style="width:90px;display:inline-block;color:red;font-weight:bold;font-size:16px;"
                                      >{{ item.total_payment }}</span
                                    >
                                    元
                                  </p>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td class="order-items">
                                  <ul class="goods-list">
                                    <li
                                      data-v-1e04aab1=""
                                      v-for="(child, index) in item.item_list"
                                      :key="index"
                                    >
                                      <div
                                        data-v-1e04aab1=""
                                        class="figure figure-thumb"
                                      >
                                        <a
                                          data-v-1e04aab1=""
                                          :href="'/detail/' + child.goods_id"
                                          target="_blank"
                                        >
                                          <div
                                            class="img-box"
                                            style="width:80px;height:80px;"
                                          >
                                            <el-image
                                              :src="child.goods_image"
                                            ></el-image>
                                          </div>
                                        </a>
                                      </div>
                                      <p data-v-1e04aab1="" class="name">
                                        <a
                                          data-v-1e04aab1=""
                                          :href="'/detail/' + child.goods_id"
                                          target="_blank"
                                          >{{ child.goods_name }}</a
                                        ><!---->
                                      </p>
                                      <p
                                        data-v-1e04aab1=""
                                        class="price"
                                        v-show="item.status !== 'TO_ORDER'"
                                      >
                                        价格：<span
                                          style="font-size:16px;color:red;"
                                        >
                                          {{ child.price }}</span
                                        >
                                        元 x
                                        <span
                                          style="font-size:16px;color:red;"
                                          >{{ child.qty }}</span
                                        >
                                        =
                                        <span style="font-size:16px;color:red;">
                                          {{ child.amount }}</span
                                        >
                                        元
                                      </p>
                                    </li>
                                  </ul>
                                </td>
                                <td class="order-actions">
                                  <a
                                    target="_blank"
                                    class="btn btn-small btn-primary"
                                    v-show="item.status == 'WAIT_BUYER_PAY'"
                                    @click="goConfirm(item)"
                                    >立即付款</a
                                  >
                                  <a
                                    class="btn btn-small btn-line-gray"
                                    @click="goDetail(item)"
                                  >
                                    订单详情
                                  </a>
                                  <a
                                    class="btn btn-small btn-line-gray"
                                    @click="goCheckOut(item)"
                                    v-show="item.status == 'TRADE_SUCCESS'"
                                  >
                                    申请售后
                                  </a>
                                  <a
                                    href="javascript:void(0)"
                                    class="btn btn-small btn-line-gray btn-contract"
                                    >联系客服
                                  </a>
                                  <a
                                    v-show="
                                      item.status === 'WAIT_BUYER_CONFIRM_GOODS'
                                    "
                                    @click="onReceived(item)"
                                    class="btn btn-small btn-line-gray btn-contract"
                                    >确认收货
                                  </a>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </li>
                    </ul>
                    <el-pagination
                      hide-on-single-page
                      style="text-align:right; margin-top:10px;"
                      layout="total, sizes, prev, pager, next, jumper"
                      :page-sizes="[10, 20, 50, 100]"
                      :page-size="pagination.limit"
                      :current-page="pagination.current"
                      :total="pagination.total"
                      @size-change="changePageSize"
                      @current-change="changeCurrentPage"
                    >
                    </el-pagination>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="is_popup_received" title="确认收货">
      <span>请收到商品检查无误后再确认收货</span>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="is_popup_received = false">取消</el-button>
          <el-button type="primary" @click="saveReceived">确认</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import LeftNav from "../Layout/LeftNav.vue";
import { api } from "@/assets/js/util.js";
export default {
  name: "Profile",
  components: {
    "left-nav": LeftNav,
  },
  data() {
    return {
      table_data: [],
      pagination: {},
      form: {},
      is_read_only: false,
      active_tab: "ALL",
      is_loading: false,
      is_popup_received: false,
      order_no: "",
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    onReceived(item) {
      this.is_popup_received = true;
      this.order_no = item.order_no;
    },
    saveReceived() {
      let that = this;
      api
        .post("order/received", { order_no: that.order_no })
        .then(function(res) {
          if (res.code) {
            that.$message("确认收货");
            that.is_popup_received = false;
            that.getData();
          }
        });
    },
    goConfirm(item) {
      let that = this;
      that.$router.push("/order/confirm/" + item.id);
    },
    goCheckOut(inquiry) {
      let that = this;
      let params = {
        inquiry_id: inquiry.id,
        from: "inquiry",
      };
      api.post("order/preview", params).then(function(res) {
        if (res.code) {
          that.$message({
            type: "success",
            message: res.msg,
            duration: 1200,
            onClose: function() {
              that.$router.push("/order/checkout/" + res.data.id);
            },
          });
        } else {
          that.$message(res.msg);
          return false;
        }
      });
    },
    goDetail(item) {
      this.$router.push("/order/detail/" + item.order_no);
    },
    onClickTab(name) {
      this.active_tab = name;
      this.getData();
    },
    getTabClass(name) {
      if (name == this.active_tab) {
        return "active";
      }
    },
    changePageSize(page_size) {
      this.pagination.limit = page_size;
      this.getData();
    },
    changeCurrentPage(current) {
      this.pagination.current = current;
      this.getData();
    },
    getData() {
      let that = this;
      that.is_loading = true;
      let params = Object.assign(this.form, {
        page: that.pagination.current,
        limit: that.pagination.limit,
        status: that.active_tab,
      });
      api.get("order/list", params).then(function(res) {
        if (res.code) {
          that.table_data = res.data;
          that.pagination.total = res.count;
          that.pagination.current = res.page;
          that.pagination.limit = res.limit;
          that.is_loading = false;
        }
      });
    },
  },
};
</script>
